<template>
  <div>
    <Drawer title="车队详情" width="500" :value="showEdit" :mask-closable="true" @on-close="cancelEdit">


        <Card>
          <Form ref="editForm" :label-width="100" :model="formData">
            <FormItem label="名称" prop="account">
              <Input v-model="formData.company_name" placeholder="" maxlength="100"></Input>
            </FormItem>
            <FormItem label="合作公司" prop="partner_company">
              <Select v-model="formData.partner_company" placeholder="请选择（可选）" clearable filterable>
                <Option
                  v-for="(item, index) in partnerCompanyOptions"
                  :key="getPartnerCompanyKey(item, index)"
                  :value="getPartnerCompanyValue(item)"
                >
                  {{ getPartnerCompanyLabel(item) }}
                </Option>
              </Select>
            </FormItem>
            <FormItem label="业务员" prop="salesman">
              <Input v-model="formData.salesman" placeholder=""></Input>
            </FormItem>
            <FormItem label="类型" prop="type">
              <Select v-model="formData.type">
                <Option value="自营车队">自营车队</Option>
                <Option value="三方车队">三方车队</Option>
              </Select>
            </FormItem>
            <!--<FormItem label="支付方式" prop="pay_type">
              <Select v-model="formData.pay_type">
                <Option value="litre">升数支付</Option>
                <Option value="amount">金额支付</Option>
              </Select>
            </FormItem>-->
            <FormItem label="显示站点" prop="station_type">
              <CheckboxGroup v-model="formData.station_type">
                <Checkbox label="2"><span>私油</span></Checkbox>
                <Checkbox label="3"><span>撬装</span></Checkbox>
                <Checkbox label="4"><span>油站</span></Checkbox>
                <Checkbox label="5"><span>充电站</span></Checkbox>
              </CheckboxGroup>
            </FormItem>
            <FormItem label="站点类型" prop="show_station_type">
              <RadioGroup v-model="formData.show_station_type">
                <Radio label="">全部</Radio>
                <Radio label="oil_station">油站</Radio>
                <Radio label="lng_station">气站</Radio>
                <Radio label="power_station">充电站</Radio>
              </RadioGroup>
            </FormItem>
            <FormItem label="支付方式" prop="pay_method" v-if="formData.show_station_type === 'power_station'">
              <RadioGroup v-model="formData.pay_method">
                <Radio label="1">车队支付</Radio>
                <Radio label="2">自行支付</Radio>
              </RadioGroup>
            </FormItem>
            <FormItem label="业务类型" prop="is_bill">
              <Select v-model="formData.is_bill">
                <Option value="0">B型</Option>
                <Option value="1">A型</Option>
              </Select>
            </FormItem>
            <FormItem label="司机端单价" prop="is_show_balance">
              <Select v-model="formData.is_show_balance">
                <Option value="1">显示</Option>
                <Option value="-1">不显示</Option>
              </Select>
            </FormItem>
            <FormItem label="是否需要拍照" prop="need_photo">
              <Select v-model="formData.need_photo">
                <Option value="0">不需要</Option>
                <Option value="1">需要拍照</Option>
              </Select>
            </FormItem>
            <FormItem label="是否填写里程" prop="need_mileage">
              <Select v-model="formData.need_mileage">
                <Option value="0">不填写</Option>
                <Option value="1">需要填写</Option>
              </Select>
            </FormItem>
            <FormItem label="是否需要支付密码" prop="is_need_pwd">
              <RadioGroup v-model="formData.is_need_pwd">
                <Radio label="1">是</Radio>
                <Radio label="0">否</Radio>
              </RadioGroup>
            </FormItem>
            <FormItem label="票价" prop="bill_amount">
              <Input v-model="formData.bill_amount" placeholder=""></Input>
            </FormItem>
            <!--<FormItem label="单价" prop="unit_price">
              <Input v-model="formData.unit_price" placeholder="单价"></Input>
            </FormItem>-->
            <FormItem label="联系人" prop="manager_name">
              <Input v-model="formData.manager_name" placeholder="" maxlength="50"></Input>
            </FormItem>
            <FormItem label="联系电话" prop="manager_mobile">
              <Input v-model="formData.manager_mobile" placeholder="该手机号将作为登录账号" maxlength="50"></Input>
            </FormItem>
            <FormItem label="登录密码" prop="password">
              <Input v-model="formData.password" placeholder="新增或修改必填，不修改则不填" maxlength="50"></Input>
            </FormItem>
            <FormItem label="OBD账号" prop="obd_account">
              <Input v-model="formData.obd_account" placeholder=""></Input>
            </FormItem>
            <FormItem label="OBD密码" prop="obd_pwd">
              <Input v-model="formData.obd_pwd"></Input>
            </FormItem>
            <FormItem label="自动上账" prop="is_auto_recharge">
              <RadioGroup v-model="formData.is_auto_recharge">
                <Radio label="0">关闭</Radio>
                <Radio label="1">开通</Radio>
              </RadioGroup>
            </FormItem>
            <FormItem label="车牌号识别" prop="is_need_car_number_ocr">
              <RadioGroup v-model="formData.is_need_car_number_ocr">
                <Radio label="0">关闭</Radio>
                <Radio label="1">开通</Radio>
              </RadioGroup>
            </FormItem>
            <FormItem label="转款银行卡号" prop="auto_recharge_opp_acct_num" v-if="formData.is_auto_recharge === '1'">
              <Input v-model="formData.auto_recharge_opp_acct_num" placeholder=""></Input>
            </FormItem>
          </Form>
        </Card>

        <div class="drawer-footer">
          <Button style="margin-right: 8px" @click="cancelEdit">取消</Button>
          <Button type="primary" @click="doSubmit">确定</Button>
        </div>


    </Drawer>
  </div>
</template>

<script>
  export default {
    name: "edit",
    props:{
      showEdit:{
        type:Boolean,
        default: false
      },
      companyId:{
        type:Number,
        default: 0
      }
    },
    data(){
      return {
        baseInfo:{},
        partnerCompanyOptions:[],
        formData:{
          company_id:0,
          company_name:'',
          partner_company:'',
          manager_name:'',
          manager_mobile:'',
          password:'',
          type:'',
          station_type:[],
          is_bill:'',
          bill_amount:'0',
          need_photo:'0',
          need_mileage:'0',
          is_need_pwd:'0',
          unit_price:'',
          obd_account:'',
          obd_pwd:'',
          salesman:'',
          show_station_type:'',
          is_show_balance:'',
          pay_method: '1',
          is_auto_recharge: '0',
          is_need_car_number_ocr: '0',
          auto_recharge_opp_acct_num: '',
        }
      }
    },
    methods:{
      getPartnerCompanyKey(item, index){
        if (item && typeof item === 'object' && item.company_id !== undefined && item.company_id !== null) {
          return item.company_id
        }
        return index
      },
      getPartnerCompanyValue(item){
        if (!item) return ''
        if (typeof item === 'string') return item
        if (typeof item === 'object') return item.company_name || ''
        return ''
      },
      getPartnerCompanyLabel(item){
        return this.getPartnerCompanyValue(item)
      },
      async getInfo(){
        let res = await this.$commonFun.postProxy('admin/company/getCompanyInfo',{company_id:this.companyId});
        this.$commonFun.dealApiResult(res,()=>{
          this.formData = res.data
          this.formData.need_photo = res.data.need_photo + ''
          this.formData.need_mileage = res.data.need_mileage + ''
          this.formData.is_show_balance = res.data.is_show_balance + ''
          this.formData.is_need_pwd = res.data.is_need_pwd + ''
          this.formData.pay_method = res.data.pay_method + ''
          this.formData.is_auto_recharge = (res.data.is_auto_recharge || 0) + ''
          this.formData.is_need_car_number_ocr = (res.data.is_need_car_number_ocr || 0) + ''
          this.formData.auto_recharge_opp_acct_num = res.data.auto_recharge_opp_acct_num || ''
        })
      },
      async getPartnerCompanies(){
        let res = await this.$commonFun.postProxy('admin/company/getPartnerCompanyList',{company_id:this.companyId});
        this.$commonFun.dealApiResult(res,()=>{
          this.partnerCompanyOptions = res.data || [];
        })
      },
      cancelEdit(){
         this.$emit('cancel-edit')
      },
      async doSubmit(){
        let res = await this.$commonFun.postProxy('admin/company/editCompany',this.formData);
        this.$commonFun.dealApiResult(res,()=>{
          this.$commonFun.successTip(res.msg,()=>{
            this.$emit('edit-success')
          })
        })
      }
    },
    mounted() {
      this.getPartnerCompanies()
      if (this.companyId>0){
        this.getInfo()
      }
    },
  }
</script>

<style scoped lang="less">
  .drawer-footer{
    width: 100%;
    /*position: absolute;*/
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    background: #fff;
  }

</style>
